exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color-picker {\n  margin-left: 8px;\n  height: 23px;\n  width: 60px;\n  position: absolute;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/custom-color-selector/custom-color-selector.component.less
// module id = ../../../../../src/app/shared/custom-color-selector/custom-color-selector.component.less
// module chunks = 2